import { FC } from 'react';

import './style.scss';

export const PlaceholderFooter: FC = () => {
  return <div className="placeholder-footer" />;
};
